import { PermissionsGate, PermissionsGateProps } from 'features/permissions'
import React, { FC } from 'react'
import {
  PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
  PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
} from 'types'

export const AssetHealthFeaturePermissionGate: FC<
  Omit<PermissionsGateProps, 'requires' | 'operation'>
> = ({ children, ...props }) => {
  return (
    <PermissionsGate
      {...props}
      requires={[
        PERMISSION_CANTILEVER_HEALTH_PLAN_VIEWER,
        PERMISSION_CANTILEVER_HEALTH_PLAN_EDITOR,
        PERMISSION_GECKO_INTERNAL_MEMBER,
      ]}>
      {children}
    </PermissionsGate>
  )
}
